import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { createElement, Fragment } from 'react';
import PrismicRichText, { Elements } from 'prismic-richtext';
import { Link as LinkHelper } from 'prismic-helpers';
import { embeds } from './embeds';
var createScript = typeof window !== "undefined" ? require("./embeds").createScript : function () {};

function serialize(linkResolver, elements, type, element, content, children, index) {
  if (elements[type]) {
    return serializeElement(elements[type], type, element, content, children, index);
  }

  switch (type) {
    case Elements.heading1:
      return serializeStandardTag('h1', element, children, index);

    case Elements.heading2:
      return serializeStandardTag('h2', element, children, index);

    case Elements.heading3:
      return serializeStandardTag('h3', element, children, index);

    case Elements.heading4:
      return serializeStandardTag('h4', element, children, index);

    case Elements.heading5:
      return serializeStandardTag('h5', element, children, index);

    case Elements.heading6:
      return serializeStandardTag('h6', element, children, index);

    case Elements.paragraph:
      return serializeStandardTag('p', element, children, index);

    case Elements.preformatted:
      return serializeStandardTag('pre', element, children, index);

    case Elements.strong:
      return serializeStandardTag('strong', element, children, index);

    case Elements.em:
      return serializeStandardTag('em', element, children, index);

    case Elements.listItem:
      return serializeStandardTag('li', element, children, index);

    case Elements.oListItem:
      return serializeStandardTag('li', element, children, index);

    case Elements.list:
      return serializeStandardTag('ul', element, children, index);

    case Elements.oList:
      return serializeStandardTag('ol', element, children, index);

    case Elements.image:
      return serializeImage(linkResolver, element, index);

    case Elements.embed:
      return serializeEmbed(element, index);

    case Elements.hyperlink:
      return serializeHyperlink(linkResolver, element, children, index);

    case Elements.label:
      return serializeLabel(element, children, index);

    case Elements.span:
      return serializeSpan(content);

    default:
      return null;
  }
}

function propsWithUniqueKey() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var key = arguments.length > 1 ? arguments[1] : undefined;
  return Object.assign(props, {
    key: key
  });
}

function serializeElement(Element, type, props, content, children, index) {
  return createElement(Element, _objectSpread(_objectSpread({
    key: "element-".concat(type, "-").concat(index + 1)
  }, props), {}, {
    children: children && children.length ? children : undefined
  }, type === 'image' ? {
    src: props.url,
    url: undefined
  } : null));
}

function serializeStandardTag(tag, element, children, key) {
  var props = element.label ? Object.assign({}, {
    className: element.label
  }) : {};
  return createElement(tag, propsWithUniqueKey(props, key), children);
}

function serializeHyperlink(linkResolver, element, children, key) {
  var targetAttr = element.data.target ? {
    target: element.data.target
  } : {};
  var relAttr = element.data.target ? {
    rel: 'noopener'
  } : {};
  var props = Object.assign({
    href: LinkHelper.url(element.data, linkResolver)
  }, targetAttr, relAttr);
  return createElement('a', propsWithUniqueKey(props, key), children);
}

function serializeLabel(element, children, key) {
  var props = element.data ? Object.assign({}, {
    className: element.data.label
  }) : {};
  return createElement('span', propsWithUniqueKey(props, key), children);
}

function serializeSpan(content) {
  if (content) {
    return content.split("\n").reduce(function (acc, p) {
      if (acc.length === 0) {
        return [p];
      } else {
        var brIndex = (acc.length + 1) / 2 - 1;
        var br = createElement('br', propsWithUniqueKey({}, brIndex));
        return acc.concat([br, p]);
      }
    }, []);
  } else {
    return null;
  }
}

function serializeImage(linkResolver, element, key) {
  var linkUrl = element.linkTo ? LinkHelper.url(element.linkTo, linkResolver) : null;
  var linkTarget = element.linkTo && element.linkTo.target ? {
    target: element.linkTo.target
  } : {};
  var relAttr = linkTarget.target ? {
    rel: 'noopener'
  } : {};
  var img = createElement('img', {
    src: element.url,
    alt: element.alt || ''
  });
  return createElement('p', propsWithUniqueKey({
    className: [element.label || '', 'block-img'].join(' ')
  }, key), linkUrl ? createElement('a', Object.assign({
    href: linkUrl
  }, linkTarget, relAttr), img) : img);
}

function serializeEmbed(element, key) {
  if (embeds[element.oembed.provider_name]) {
    createScript(embeds[element.oembed.provider_name]);
  }

  var className = "embed embed-".concat(element.oembed.provider_name.toLowerCase());
  var props = Object.assign({
    "data-oembed": element.oembed.embed_url,
    "data-oembed-type": element.oembed.type,
    "data-oembed-provider": element.oembed.provider_name,
    ref: function ref(_ref) {
      if (embeds[element.oembed.provider_name]) {
        embeds[element.oembed.provider_name].load(_ref);
      }
    }
  }, element.label ? {
    className: "".concat(className, " ").concat(element.label)
  } : {
    className: className
  });
  var embedHtml = createElement('div', {
    dangerouslySetInnerHTML: {
      __html: element.oembed.html
    }
  });
  return createElement('div', propsWithUniqueKey(props, key), embedHtml);
}

export var asText = function asText(structuredText) {
  if (Object.prototype.toString.call(structuredText) !== '[object Array]') {
    console.warn("Rich text argument should be an Array. Received ".concat(typeof structuredText));
    return null;
  }

  return PrismicRichText.asText(structuredText);
};
export var renderRichText = function renderRichText(richText, linkResolver, htmlSerializer) {
  var Component = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Fragment;
  var elements = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var args = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  if (Object.prototype.toString.call(richText) !== '[object Array]') {
    console.warn("Rich text argument should be an Array. Received ".concat(typeof richText));
    return null;
  }

  var serializedChildren = PrismicRichText.serialize(richText, serialize.bind(null, linkResolver, elements), htmlSerializer);
  return createElement(Component, args, serializedChildren);
};